import { Box, Flex, Text, Textarea } from '@chakra-ui/react'
import { WorkflowsContext } from '@context'
import { Field, Form, Formik } from 'formik'
import { cloneDeep } from 'lodash'
import React, { useContext } from 'react'
import * as Yup from 'yup'
import { EditDrawerFooter } from '../../edit-drawer/edit-drawer-footer'
import type { FormattedNode } from '../../format-nodes'

type Props = {
  onSubmit: (node: FormattedNode | undefined) => void
  closeDrawer: () => void
  onDelete: (node: FormattedNode | undefined) => void
}

const configSchema = Yup.object().shape({
  smsBody: Yup.string().required()
})

export const SendClientSms = ({ onSubmit, closeDrawer, onDelete }: Props) => {
  const { selectedNode } = useContext(WorkflowsContext)

  const initialValues = selectedNode?.config || {
    smsBody: undefined
  }

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={configSchema}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={values => {
          const node = cloneDeep(selectedNode) as FormattedNode
          node.config = values || {}
          onSubmit(node)
        }}
      >
        {({ values, errors, resetForm }) => (
          <Form>
            <Field name="smsBody">
              {({ field }: { field: { value: string } }) => (
                <>
                  <Text>Message:</Text>
                  <Flex direction="column">
                    <Textarea
                      {...field}
                      placeholder="Enter message here..."
                      borderColor={errors?.smsBody ? 'error' : 'light_gray'}
                      color={field.value ? 'black' : 'gray'}
                      maxLength={160}
                      w="100%"
                      mt="xsmall"
                      mb="xxsmall"
                    />
                    <Text
                      mb="small"
                      color="dark_gray"
                      alignSelf="end"
                      fontSize="sm"
                    >{`${
                      160 - (field?.value?.length || 0)
                    } characters left`}</Text>
                  </Flex>
                </>
              )}
            </Field>
            <EditDrawerFooter
              onDelete={() => onDelete(selectedNode)}
              onCancel={closeDrawer}
            />
          </Form>
        )}
      </Formik>
    </Box>
  )
}
